import React from 'react'
import { TextField, FormControl, FormHelperText } from '@material-ui/core'
import cn from 'classnames'

function SelectInput({
  input,
  label,
  disabled,
  required,
  inputProps,
  onChange,
  children,
  className,
  meta: { submitError, touched, error },
}) {
  let errorMessage = null
  let errorStatus = false

  if (touched && (error || submitError)) {
    errorStatus = true
    errorMessage = error || submitError
  }

  return (
    <div className={cn('form-group', { [className]: className })}>
      <FormControl fullWidth component="div" error={errorStatus}>
        <TextField
          {...input}
          {...inputProps}
          select
          error={errorStatus}
          label={label}
          disabled={disabled}
          required={required}
          onChange={onChange}>
          {children}
        </TextField>
        {errorStatus && <FormHelperText>{errorMessage}</FormHelperText>}
      </FormControl>
    </div>
  )
}

export default SelectInput
